<template>
  <div
    :class="containerClass"
  >
    <img
      :class="imgClass"
      alt="Partnering with nCino"
      data-cy="sn-partnering"
      src="/assets/ncino-watermark.svg"
    >
  </div>
</template>

<script>

export default {
  name: 'PartnerFooter',
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.mdAndDown
    },
    imgClass () {
      return this.isMobile ? 'mobile-partner-image' : 'sn-partner-image'
    },
    containerClass () {
      return this.isMobile ? 'container' : 'container web-container'
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.container {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 16px 24px 24px 24px;
}

.web-container {
  height: 200px;
}

.mobile-partner-image {
  width: 75%;
}

.sn-partner-image {
  width: 225px;
  margin-bottom: 6%;
}

</style>
